import { COL } from "./columns";
import { normalizeValue } from "./utils";

function safeRegex(value) {
  try {
    return new RegExp(value);
  } catch (error) {
    return null;
  }
}

/** 住所照合用。ヶ/ケの表記ゆれをケにそろえる */
export function normalizeKeGa(value) {
  return normalizeValue(value).replace(/ヶ/g, "ケ");
}

export function splitAddr(addr) {
  const match = normalizeValue(addr).match(/^(北海道|東京都|京都府|大阪府|.{2,3}県)?(.*)$/u);
  return [match?.[1] || "", match?.[2] || ""];
}

/**
 * 入力住所とCSV行が一致するか。
 * マスタは「龍ケ崎市」「茅ヶ崎市」のようにヶ/ケが混在するため、
 * 入力・CSVの両方をケにそろえてから比較する。
 */
export function isAddrMatch(todoufuken, city, row) {
  const pref = normalizeKeGa(row[COL.TODOUFUKEN]);
  const rowCity = normalizeKeGa(row[COL.CITY]);
  const inputPref = normalizeKeGa(todoufuken);
  const inputCity = normalizeKeGa(city);
  if (!pref && !rowCity) return true;
  if (inputPref && pref !== inputPref) return false;

  const startsWith = `${normalizeKeGa(row[COL.GUN])}${rowCity}`;
  if (!inputCity.startsWith(startsWith)) return false;

  const excludes = normalizeValue(row[COL.EXCITY]).split(":").filter(Boolean);
  for (const value of excludes) {
    const normalized = normalizeKeGa(value);
    const regex = safeRegex(normalized);
    if (regex ? regex.test(inputCity) : inputCity.includes(normalized)) return false;
  }
  return true;
}

export function sortByRank(a, b) {
  return Number.parseInt(a[COL.RANK] || "99999", 10) - Number.parseInt(b[COL.RANK] || "99999", 10);
}
